export default function roomRecordEventListener(room) {
  return store => {
    room.addEventListeners({
        room_record_init: e => {
            store.commit('record/RECORD_FILE_INIT', e.data)
        },
        room_record_changeClientRecordState: e => {
            store.commit('record/CHANGE_CLIENT_RECORD_STATE', e.data)
        },
        room_record_recordServerSendRemainStart: e => {
            store.commit('record/RECORD_SERVER_SEND_REMAIN_START', e.data)
        },
        room_record_recordServerSendRemainProgress: e => {
            store.commit('record/RECORD_SERVER_SEND_REMAIN_PROGRESS', e.data)
        },
        room_record_recordError: e => {
            store.commit('record/RECORD_ERROR', e.data)
        },
        room_user_recordFileSaved: e => {
            store.commit('record/RECORD_FILE_ADD', e.data)
        },
        room_record_forceToStop: e => {
            store.commit('record/CHANGE_CLIENT_RECORD_STATE', e.data)
        },
    });
  }
}
